import { gql } from "@apollo/client";

//queries

export const QUERY_COMPANY_BRANCHES = gql`
  query ($operatorId: ID!, $selectedPartnerCompany: ID) {
    searchBranches(
      operatorId: $operatorId
      partnerId: $selectedPartnerCompany
    ) {
      partnerBranchId
      partnerBranch
    }
  }
`;
export const QUERY_COMPANY_NKCNAME = gql`
  query ($operatorId: ID!) {
    partners(operatorId: $operatorId) {
      partnerId
      companyNickname
    }
  }
`;

export const QUERY_LOCKER_TYPE = gql`
  query {
    lockerTypes {
      lockerTypeId
      lockerType
    }
  }
`;

export const QUERY_LOCKER_NAME = gql`
  query ($operatorId: ID!, $selectedLockerType: Int) {
    lockers(operatorId: $operatorId, lockerTypeId: $selectedLockerType) {
      lockerName
      lockerId
    }
  }
`;

export const QUERY_PARTNER_PERFORMANCE_REPORTS = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $selectedLockerName: [Int]
    $selectedPartnerCompany: ID
    $selectedPartnerBranch: [Int]
  ) {
    partnerPerformanceByLocker(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockerIds: $selectedLockerName
      partnerId: $selectedPartnerCompany
      partnerBranchIds: $selectedPartnerBranch
    ) {
      partnerId
      partnerName
      lockers {
        lockerId
        name
        packages
        __typename
      }
      partnerBranchId
      __typename
    }
  }
`;

export const QUERY_CHART_DATA = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $selectedLockerName: [Int]
    $selectedPartnerCompany: ID
    $selectedPartnerBranch: [Int]
    $selectedRadio: String
  ) {
    partnerPerformanceByDay(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockerIds: $selectedLockerName
      partnerId: $selectedPartnerCompany
      partnerBranchIds: $selectedPartnerBranch
      period: $selectedRadio
    ) {
      date
      partners {
        partnerId
        name
        lockers
        packages
        __typename
      }
      __typename
    }
  }
`;

export const QUERY_PARTNER_BRANCH_PERFORMANCE_BY_DAY = gql`
  query (
    $operatorId: ID!
    $dateStart: Date!
    $dateEnd: Date!
    $selectedLockerName: [Int]
    $selectedPartnerCompany: ID
    $selectedPartnerBranch: [Int]
    $selectedRadio: String
  ) {
    partnerPerformanceByDayWithBranches(
      operatorId: $operatorId
      dateStart: $dateStart
      dateEnd: $dateEnd
      lockerIds: $selectedLockerName
      partnerId: $selectedPartnerCompany
      partnerBranchIds: $selectedPartnerBranch
      period: $selectedRadio
    ) {
      date
      partnerBranches {
        partnerName
        partnerId
        partnerBranchId
        partnerBranch
        packages
      }
      __typename
    }
  }
`;
